
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#E2E2E2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.602 9.522a.646.646 0 00-.58-.356H8.98a.645.645 0 00-.58.356.627.627 0 00.07.669l5.461 6.908v4.973c0 .236.195.427.434.427h1.273c.24 0 .434-.191.434-.427v-4.973l5.46-6.908a.626.626 0 00.07-.669zm-2.207 1.304l-4.2 5.314a.248.248 0 01-.388 0l-4.2-5.314a.242.242 0 01.194-.39h8.4c.204 0 .32.231.194.39z","fill":"#333"}})])
          )
        }
      }
    